module.exports = __webpack_public_path__ + "static/media/Raleway-SemiBold.8a192102.ttf";